import { useQuery } from "@tanstack/react-query";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { TypedTable } from "../../../../components/TypedTable";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { Loading, QueryError } from "../../../../components/Loading/Loading";

interface ModalOrdenFabricacionListadoProps extends BaseModalProps { readonly xconjunto_id: string | null; }
export function ModalOrdenFabricacionListado(props: ModalOrdenFabricacionListadoProps) {
	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Ordenes de fabricación</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="content-box big-box">
					<div className="table-responsive">
						{props.xconjunto_id != null && (
							<OrdenFabricacionFabrica xconjunto_id={props.xconjunto_id} />
						)}
					</div>
				</div>
				<div className="modal-footer">
					<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				</div>
			</div>
		</BaseModal>
	);
}

function OrdenFabricacionFabrica(props: { readonly xconjunto_id: string; }) {
	const { data, error, isPending } = UseOrdenesConjunto({ xconjunto_id: props.xconjunto_id });

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<OrdenConjunto>();
		const formatter = new Intl.NumberFormat("es-ES", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 });
		return [
			columnHelper.accessor("xof_id", { header: "OF" }),
			columnHelper.accessor("xcant_lanzada", {
				header: "Cantidad",
				cell: info => formatter.format(Number(info.getValue())),
			}),
			columnHelper.accessor("xfecha_lanz", { header: "Fecha lanzada" }),
		];
	}, []);

	if (error) return <QueryError error={error} fallback="Error al cargar las órdenes de fabricación" />;
	if (isPending) return <Loading />;

	return (
		<TypedTable
			className="display dataTable"
			data={data}
			columns={columns}
			pagination
		/>
	);
}
interface OrdenesConjuntoParams {
	xconjunto_id: string;
}
function UseOrdenesConjunto(params: OrdenesConjuntoParams) {
	return useQuery<OrdenConjunto[]>({
		queryKey: ["getOrdenesConjunto", { idConjunto: params.xconjunto_id }],
		queryFn: () => ComunicacionAjax.sendAjaxRequest<OrdenConjunto[]>("GET", "/getOrdenesConjunto", params),
	});
}
type OrdenConjunto = Record<string, string>;